import React from 'react';

import { Button, Group, Stack, Text } from '@mantine/core';
import useDeletePackageCategory from 'hooks/packageCategory/useDeletePackageCategory';
import { PackageCategory } from 'types';
import notificationHandler from 'utils/notifications';

interface IDeletePackageCategoryModalProps {
  packageCategory: PackageCategory;
  handleClose: () => void;
}

const DeletePackageCategoryModal = ({
  packageCategory,
  handleClose,
}: IDeletePackageCategoryModalProps): JSX.Element => {
  const deletePackageCategoryMutation = useDeletePackageCategory();

  const handleDelete = (): void => {
    const { successNotification, errorNotification } = notificationHandler();
    deletePackageCategoryMutation.mutate(packageCategory.packageCategoryId, {
      onSuccess: () => {
        successNotification(
          'Package Category delete success',
          `${packageCategory.name} successfully deleted.`,
        );
        handleClose();
      },
      onError: error => {
        errorNotification('Package Category delete failed', error.response?.data.message);
      },
    });
  };
  return (
    <Stack>
      <Text>{`Are you sure you want to delete ${packageCategory.name}?`}</Text>
      <Text color='dimmed'>This action cannot be undone.</Text>
      <Group position='right'>
        <Button onClick={handleDelete} color='red' loading={deletePackageCategoryMutation.isLoading}>
          Delete
        </Button>
      </Group>
    </Stack>
  );
};

export default DeletePackageCategoryModal;
